module.exports = new __parcel__URL__("Alvin.617c22ff.svg").toString();